export default __webpack_public_path__ + "static/media/ic-file-image.565f68df.svg";